<div class="container-fluid">
  <div mat-dialog-title>
    <ng-container *ngIf="changeOrderSummary.changeOrderItem.quoteArea_ID; then editChangeOrder; else newChangeOrder"></ng-container>
    <ng-template #newChangeOrder i18n>New Product Change Order</ng-template>
    <ng-template #editChangeOrder i18n>Edit Product Change Order</ng-template>
  </div>
  <div mat-dialog-content>
    <form #areaForm="ngForm" (ngSubmit)="saveArea(areaForm)">
      <p i18n>Please enter product information for quote area</p>
      <div *ngIf="!changeOrderSummary.changeOrderItem.quoteArea_ID" class="form-group row">

        <div class="form-group-row">
          <div class="form-inline">
            <input type="checkbox" name="changeOrderItem_IsCustomItem"
                   id="changeOrderItem_IsCustomItem" class="bidit-switch-sm ml-1 mr-1" [(ngModel)]="changeOrderSummary.changeOrderItem.changeOrderItem_IsCustomItem" />
            <label>Custom Item</label>
          </div>
        </div>

      </div>

      <div *ngIf="changeOrderSummary.changeOrderItem.changeOrderItem_IsCustomItem">
        <div class="col-sm-12 form-inline">
          <div class="control-wrapper">
            <label for="area_Name" i18n>Line Item Description</label>
            <input name="area_Name" type="Text" class="form-control" maxlength="50"
                   [(ngModel)]="changeOrderSummary.changeOrderItem.changeOrderItem_Name" #changeOrderItem_Name="ngModel" />
            <div [hidden]="!areaForm.submitted || changeOrderItem_Name.valid"
                 class="alert alert-danger" i18n>Description not valid</div>
          </div>
          <div class="control-wrapper">
            <label for="changeOrderItem_Note">Product</label>
            <input name="changeOrderItem_Note" type="Text" class="form-control" maxlength="50"
                   placeholder="Enter Product Description"
                   [(ngModel)]="changeOrderSummary.changeOrderItem.changeOrderItem_Note" #changeOrderItem_Note="ngModel" />
            <div [hidden]="!areaForm.submitted || changeOrderItem_Note.valid"
                 class="alert alert-danger" i18n>Enter a product description</div>
          </div>
        </div>
        <div class="form-group row mt-3">
          <div class="col-sm-12 form-inline">
            <div class="control-wrapper">
              <label for="changeOrderItem_ItemCost" class="col-sm-4 col-form-label">
                <span i18n>Custom Item Cost</span>
              </label>
              <input name="changeOrderItem_ItemCost" type="number" class="form-control"
                     message="Custom Item Cost must be numeric." placeholder="$ Enter cost" i18n-placeholder
                     [(ngModel)]="changeOrderSummary.changeOrderItem.changeOrderItem_ItemCost" #changeOrderItem_ItemCost="ngModel" />
            </div>
            <div class="control-wrapper">
              <label for="changeOrderItem_ExtraLaborAdjustment" class="col-sm-4 col-form-label">
                <span i18n>Additional Labor Adjustment</span>
              </label>
              <input name="changeOrderItem_ExtraLaborAdjustment" type="number" class="form-control"
                     message="Additional Labor must be numeric." placeholder="$ Enter additional labor" i18n-placeholder
                     [(ngModel)]="changeOrderSummary.changeOrderItem.changeOrderItem_ExtraLaborAdjustment" #changeOrderItem_ExtraLaborAdjustment="ngModel" />
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!changeOrderSummary.changeOrderItem.changeOrderItem_IsCustomItem">

        <div class="col-sm-12 form-inline">
          <div *ngIf="changeOrderSummary.changeOrderItem.quoteArea_ID==null; then thenBlock else elseBlock" class="control-wrapper"></div>
          <ng-template #thenBlock>
            <span class="warning">* </span>
            <label for="area_ID" i18n>Area</label>
            <select name="area_ID" class="form-control select-bidit"
                    required=""
                    [(ngModel)]="changeOrderSummary.changeOrderItem.area_ID" #area_ID="ngModel" (ngModelChange)="onAreaChange($event)">
              <option *ngFor="let area of areas" [ngValue]="area.area_ID">{{area.area_Name}}</option>
            </select>
            <div [hidden]="!areaForm.submitted || area_ID.valid"
                 class="alert alert-danger" i18n>Select an area</div>
          </ng-template>
          <ng-template #elseBlock>
          </ng-template>

          <div class="control-wrapper">
            <span class="warning">* </span>
            <label for="subArea_ID" i18n>Sub Area</label>
            <ng-template [ngIf]="changeOrderSummary && changeOrderSummary.area">
              <select name="subArea_ID" class="form-control select-bidit"
                      required=""
                      [(ngModel)]="changeOrderSummary.changeOrderItem.subArea_ID" #subArea_ID="ngModel">
                <option [ngValue]="undefined">-</option>
                <option *ngFor="let subArea of changeOrderSummary.area.subAreas" [ngValue]="subArea.subArea_ID">{{subArea.subArea_Name}}</option>
              </select>
              <div [hidden]="!areaForm.submitted || subArea_ID.valid"
                   class="alert alert-danger" i18n>Select a sub area</div>
            </ng-template>
            <ng-template [ngIf]="changeOrderSummary && changeOrderSummary.area == null">
              <div class="form-control" i18n>Select Area</div>
            </ng-template>
          </div>

          <div class="control-wrapper">
            <label for="area_Name" i18n>Alias</label>
            <input name="area_Name" type="Text" class="form-control" maxlength="50"
                   [(ngModel)]="changeOrderSummary.changeOrderItem.changeOrderItem_Name" #changeOrderItem_Name="ngModel" />
            <div [hidden]="!areaForm.submitted || changeOrderItem_Name.valid"
                 class="alert alert-danger" i18n>Alias not valid</div>
          </div>
        </div>
      </div>
      <div class="form-group row mt-3">
        <label for="productFilterItemType_ID" class="col-sm-3 col-form-label">
          <span class="warning">* </span><span i18n>Product</span>
          <span class="float-right">Filter:</span>
        </label>
        <div class="col-sm-9 form-inline">
          <select name="productFilterItemType_ID" class="form-control select-bidit"
                  [(ngModel)]="productFilterItemType_ID" (ngModelChange)="refreshProductItemType()">
            <option value="undefined" selected="selected" disabled hidden i18n>Choose Item Type... </option>
            <option [ngValue]="undefined" style="color:black;"> - </option>
            <option *ngFor="let itemType of itemTypes" [ngValue]="itemType.itemType_ID">{{itemType.itemType_Desc}}</option>
          </select>
          <select *ngIf="!productUsage && !productAeroBarrier" name="productFilterRValue" class="form-control select-bidit"
                  [(ngModel)]="productFilterRValue" (ngModelChange)="refreshProductItems()">
            <option value="undefined" selected="selected" disabled="" hidden="" i18n>Choose R-Value... </option>
            <option [ngValue]="undefined" style="color:black;"> - </option>
            <option *ngFor="let rValue of productRValues" [ngValue]="rValue.rValue_ID">{{rValue.rValue_Desc}}</option>
          </select>
        </div>
        <div class="row">
        </div>
      </div>
      <div class="form-group row">
        <label for="item_ID" class="col-sm-3 col-form-label"></label>
        <div class="col-sm-9 form-inline">
          <select id="item_ID" name="item_ID" class="form-control select-bidit"
                  required="" appValidateItemCost
                  [(ngModel)]="changeOrderSummary.changeOrderItem.item_ID" #item_ID="ngModel"
                  (ngModelChange)="refreshProductUsages()">
            <option [ngValue]="undefined" selected="selected"> - </option>
            <option *ngFor="let productItem of productItems" [ngValue]="productItem.item_ID">
              <ng-template [ngIf]="productItem.item_Part">{{productItem.item_Part}}, </ng-template>{{productItem.item_Name}}
            </option>
          </select>
          <div *ngIf="areaForm.submitted && areaForm.controls['item_ID']?.errors?.itemPriceValidator"
               class="alert alert-danger">
            {{areaForm.controls['item_ID']?.errors.itemPriceValidator}}
          </div>
          <div *ngIf="productUsage">
            <span i18n>Coverage:</span>
            <select name="itemUsage_ID" class="form-control select-bidit"
                    required=""
                    [(ngModel)]="changeOrderSummary.changeOrderItem.itemUsage_ID" #itemUsage_ID="ngModel">
              <option [ngValue]="undefined" selected="selected"> - </option>
              <option *ngFor="let itemUsage of productUsages" [ngValue]="itemUsage.itemUsage_ID">{{itemUsage.rValue.rValue_Desc}}</option>
            </select>
            <div [hidden]="!areaForm.submitted || itemUsage_ID.valid"
                 class="alert alert-danger" i18n>Select a coverage</div>
          </div>
          <div [hidden]="!areaForm.submitted || !areaForm.controls['item_ID']?.errors?.required"
               class="alert alert-danger" i18n>Select a product</div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-12 form-inline">
          <div class="control-wrapper">
            <label for="changeOrderItem_SqrFtg" class="col-sm-4 col-form-label">
              <span i18n>Square Footage Adjustment</span>
              <ng-template [ngIf]="changeOrderSummary.changeOrderItem.quoteArea_ID != null">
                (current: {{changeOrderSummary.quoteArea.acceptedItem.area_SqrFtg}})
              </ng-template>
            </label>
            <input name="changeOrderItem_SqrFtgAdjustment" type="number" class="form-control"
                   message="Square footage adjustment must be numeric."
                   [(ngModel)]="changeOrderSummary.changeOrderItem.changeOrderItem_SqrFtgAdjustment" #changeOrderItem_SqrFtgAdjustment="ngModel" />
            <div [hidden]="!areaForm.submitted || changeOrderItem_SqrFtgAdjustment.valid"
                 class="alert alert-danger" i18n>Enter square footage adjustment</div>
          </div>
          <div class="control-wrapper">
            <label for="changeOrderItem_ExtraLaborAdjustment" class="col-sm-4 col-form-label">
              <span i18n>Additional Labor Adjustment</span>
              <ng-template [ngIf]="changeOrderSummary.changeOrderItem.quoteArea_ID != null">
                (<span i18n>current:</span> {{changeOrderSummary.quoteArea.acceptedItem.area_ExtraLabor || 0}})
              </ng-template>
            </label>
            <input name="changeOrderItem_ExtraLaborAdjustment" type="number" class="form-control"
                   message="Additional Labor must be numeric." placeholder="$ Enter additional labor" i18n-placeholder
                   [(ngModel)]="changeOrderSummary.changeOrderItem.changeOrderItem_ExtraLaborAdjustment" #changeOrderItem_ExtraLaborAdjustment="ngModel" />
          </div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-12 form-inline">
          <div class="control-wrapper">
            <label for="changeOrderItem_OtherCosts" class="col-sm-4 col-form-label">
              <span i18n>Additional Costs Adjustment</span>
              <ng-template [ngIf]="changeOrderSummary.changeOrderItem.quoteArea_ID != null">
                (<span i18n>current:</span> {{changeOrderSummary.quoteArea.acceptedItem.area_OtherCosts || 0}})
              </ng-template>
            </label>
            <input name="changeOrderItem_OtherCostsAdjustment" type="number" class="form-control"
                   message="Additional Costs must be numeric." placeholder="$ Enter additional costs" i18n-placeholder
                   [(ngModel)]="changeOrderSummary.changeOrderItem.changeOrderItem_OtherCostsAdjustment" #changeOrderItem_OtherCostsAdjustment="ngModel" />
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-6">
          <div class="control-wrapper">
            <label for="changeOrderItem_IsMaterialOnly" class="col-form-label" i18n>Material Only</label>
            <mat-radio-group name="changeOrderItem_IsMaterialOnly"
                             [(ngModel)]="changeOrderSummary.changeOrderItem.changeOrderItem_IsMaterialOnly">
              <mat-radio-button [value]="true">Yes</mat-radio-button>
              <mat-radio-button [value]="false">No</mat-radio-button>
            </mat-radio-group>
          </div>
          <div *ngIf="changeOrderSummary.area != null && changeOrderSummary.area.area_IsOption" class="control-wrapper">
            <label for="area_GrossMargin" class="col-form-label" i18n>Gross Margin %</label>
            <input name="area_GrossMargin" type="number" class="form-control"
                   [(ngModel)]="changeOrderSummary.changeOrderItem.area_GrossMargin" #area_GrossMargin="ngModel">
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="form-inline">
          <label for="lineItem_CustomNote" class="col-sm-4 col-md-1 col-form-label" i18n>Notes</label>
          <mat-checkbox class="example-margin" (change)="useTemplateChange($event.checked)">
            Use Template
          </mat-checkbox>
          <span class="col-6">
            <select *ngIf="this.showTemplates" name="quoteItemNoteTemplate" class="ml-2 form-control select-bidit"
                    [(ngModel)]=this.selectedTemplate #quoteItemNoteTemplate_ID="ngModel" (ngModelChange)=itemNoteTemplateChange($event)>
              <option [ngValue]=null selected="selected"> - </option>
              <option *ngFor="let template of data.quoteItemNoteTemplates" [ngValue]="template.quoteItemNoteTemplate_ID">{{template.quoteItemNoteTemplate_Name}}</option>
            </select>
          </span>
        </div>
        <div class="col-sm-8 col-md-11">
          <textarea class="form-control" name="lineItem_CustomNote" id="lineItem_CustomNote"
                    rows="3" maxlength="500"
                    [(ngModel)]="changeOrderSummary.changeOrderItem.changeOrderItem_CustomNotes" #changeOrderItem_CustomNotes="ngModel">
            </textarea>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-8">
          <table class="table table-bidit">

            <thead>
              <tr>
                <th i18n>Item</th>
                <th i18n>Cost</th>
                <th i18n>Quantity</th>
              </tr>
            </thead>
            <tbody>
              <ng-template [ngIf]="changeOrderSummary.changeOrderItem">
                <tr *ngIf="changeOrderSummary.changeOrderItem.accessories.length==0">
                  <td colspan="3" i18n>No defined accessories for selected area</td>
                </tr>
                <tr *ngFor="let areaItem of changeOrderSummary.changeOrderItem.accessories; let index = index;">
                  <td *ngIf="areaItem.item">
                    <strong>{{areaItem.item.item_Name}}</strong><br>
                <!--{{areaItem.item.item_SalesDesc}}-->
                  </td>
                  <td *ngIf="!areaItem.item">
                    <input name="accessory_CustomName{{index}}" class="form-control"
                           [(ngModel)]="areaItem.accessory_CustomName" #accessory_CustomName="ngModel" required />
                    <div [hidden]="!areaForm.submitted || areaItem.accessory_CustomName" class="alert alert-danger" i18n>Enter a name</div>
                  </td>
                  <td *ngIf="areaItem.item">
                    <div *ngIf="showLinePricing">
                      ${{areaItem.item.item_Cost == null ? 0 : areaItem.item.item_Cost  | number:'1.2-2'}}
                    </div>
                    <div *ngIf="!showLinePricing"></div>
                  </td>
                  <td *ngIf="!areaItem.item">
                    <div *ngIf="showItemPricing">
                      <input name="accessory_Cost{{index}}" type="number" class="form-control"
                             [(ngModel)]="areaItem.accessory_Cost" #accessory_Cost="ngModel" />
                    </div>
                    <div *ngIf="!showLinePricing"></div>
                  </td>
                  <td>
                    <input name="accessory_Quantity{{index}}" type="number" class="form-control"
                           [(ngModel)]="areaItem.accessory_Quantity" #accessory_Quantity="ngModel" />
                    <button *ngIf="!areaItem.item" type="button" class="btn btn-bidit-delete"
                            (click)="removeCustomAccessory(areaItem)" title="Remove custom accessory" i18n-title></button>
                  </td>
                </tr>
              </ng-template>
              <tr>
                <td colspan="2" i18n>Add custom accessory</td>
                <td>
                  <button type="button" class="btn btn-bidit-add" (click)="addCustomAccessory()" title="Add custom accessory" i18n-title></button>
                </td>
              </tr>
            </tbody>
          </table>

        </div>

      </div>
      <div class="row">
        <div class="col-sm-12">
          <div [hidden]="!areaForm.submitted || areaForm.valid"
               class="alert alert-danger" i18n>Validation issues encountered.  Please review your entered information.</div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <app-spinner [isRunning]="isRequesting"></app-spinner>
        </div>
        <div class="col-sm-8">
          <button type="submit" value="submit" name="submit" [disabled]="isRequesting" class="btn btn-bidit-submit mr-1" i18n>Submit</button>
          <button type="button" class="btn btn-bidit-cancel" (click)="cancelEdit()" i18n>Cancel</button>
        </div>
      </div>
    </form>
  </div>
</div>
